// extracted by mini-css-extract-plugin
module.exports = {"inputContainer":"_1f2Y-APh","label":"FvAu14NV","dollarSign":"_2PKDjjDC","input":"_1Q63q_9H"};